import { useState } from 'react';

export function useAccordionState() {
  const [open, setOpen] = useState<Set<string>>(new Set());

  const makeKey = (columnId: string, itemCode: string) => `${columnId}:${itemCode}`;

  const toggle = (columnId: string, itemCode: string) => {
    const key = makeKey(columnId, itemCode);
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };

  const isOpen = (columnId: string, itemCode: string) => open.has(makeKey(columnId, itemCode));

  const hasOpenInColumn = (columnId: string) =>
    [...open].some((key) => key.startsWith(`${columnId}:`));

  const transferOpenStates = (
    items: { itemCode: string; sourceColumnId: string }[],
    targetColumnId: string
  ) => {
    setOpen((prev) => {
      const next = new Set(prev);
      items.forEach(({ itemCode, sourceColumnId }) => {
        if (prev.has(makeKey(sourceColumnId, itemCode))) {
          next.add(makeKey(targetColumnId, itemCode));
        }
      });
      return next;
    });
  };

  const closeAll = () => setOpen(new Set());

  const hasOpen = open.size > 0;

  return {
    isOpen,
    hasOpenInColumn,
    hasOpen,
    transferOpenStates,
    toggle,
    closeAll
  };
}
